import { computed, Ref, ref, watchEffect } from 'vue'
import { useBreadcrumbsQuery } from '@server/graphql/queries/breadcrumbsQuery'
import { INodeData } from '@/types/index'

/**
 * Função para buscar os dados do breadcrumb com base no ID fornecido.
 * @param _id O ID do menu a ser buscado.
 * @returns Uma referência reativa para a lista de breadcrumbs.
 */
const fetchBreadcrumbs = (_id: string): Ref<INodeData[]> => {
  const { result } = useBreadcrumbsQuery({
    id: _id
  })

  const data = ref<INodeData[]>([])
  const resultData = computed<INodeData[]>(() => {
    if (result.value?.getBreadcrumbNodes?.payload.nodeNavigationList == null) {
      return []
    }
    return result.value.getBreadcrumbNodes.payload.nodeNavigationList
  })

  watchEffect(() => {
    if (resultData.value !== undefined) {
      data.value = resultData.value
    }
  })
  return data
}

export default fetchBreadcrumbs
